/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetApiPublicWebclientBarbers200, GetApiPublicWebclientBarbers400, GetApiPublicWebclientBarbers404, GetApiPublicWebclientBarbersQueryParams, GetApiPublicWebclientBarbersQueryResponse } from "../entities/GetApiPublicWebclientBarbers";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { modelsPublicBarbersOutputSchema } from "./models/publicBarbersOutputSchema";
import { z } from "zod/v4";

export const getApiPublicWebclientBarbersQueryParamsSchema = z.object({
    "date": z.optional(z.string().describe("Дата (YYYY-MM-DD)")),
"service_id": z.coerce.number().int().min(1).describe("ID услуги: определяет компанию и продающие её филиалы"),
"branch_id": z.optional(z.coerce.number().int().min(1).describe("ID филиала: при наличии мастера подбираются в его пределах"))
    }) as unknown as z.ZodType<GetApiPublicWebclientBarbersQueryParams>

/**
 * @description OK
 */
export const getApiPublicWebclientBarbers200Schema = z.lazy(() => modelsPublicBarbersOutputSchema) as unknown as z.ZodType<GetApiPublicWebclientBarbers200>

/**
 * @description Некорректные service_id или branch_id
 */
export const getApiPublicWebclientBarbers400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiPublicWebclientBarbers400>

/**
 * @description Филиал недоступен или услуга не найдена в его компании
 */
export const getApiPublicWebclientBarbers404Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiPublicWebclientBarbers404>

export const getApiPublicWebclientBarbersQueryResponseSchema = z.lazy(() => getApiPublicWebclientBarbers200Schema) as unknown as z.ZodType<GetApiPublicWebclientBarbersQueryResponse>